import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TenantLocalService {
  private selectedTenantPaswword: string | null = null;
  private readonly TENANT_KEY = 'tenant';
  private readonly SLUG_TENANT_KEY = 'slug_tenant';

  private tenantSlug = new BehaviorSubject<string | null>(
    localStorage.getItem(this.SLUG_TENANT_KEY)
  );
  private tenant = new BehaviorSubject<any>(
    localStorage.getItem(this.TENANT_KEY)
  );

  public tenantSlug$ = this.tenantSlug.asObservable();
  public tenant$ = this.tenant.asObservable();

  setTenantSlug(tenantId: string): void {
    localStorage.setItem(this.SLUG_TENANT_KEY, tenantId.toString());
    this.tenantSlug.next(tenantId);
  }

  getTenantSlug(): string | null {
      return this.tenantSlug.value;
  }

  setTenantPaswword(password: string): void {
      this.selectedTenantPaswword = password;
      localStorage.setItem('password', password.toString());
  }
  getTenantpPassword(): string | null {
      const password = localStorage.getItem('password');
      return this.selectedTenantPaswword || (password ? password : null);
  }

  setTenant(tenant: any) {
    localStorage.setItem(this.TENANT_KEY, JSON.stringify(tenant));
    this.tenant.next(tenant);
  }

  getTenant(): any {
      return this.tenant.value;
  }
}

